// Generated scouting report page (2026-10-16): /warriors/scouting/{gameId}
//
// Renders the `generated` report stored on gcScoutingReports/{gameId} (built by
// shared/scouting.mjs from pasted GameChanger play-by-play). Coach/admin only -- same as every
// other scouting surface, enforced by firestore.rules (isCoach() || admin), never isParent().
//
// One component, two outputs: dark Warriors theme on screen (phone-first, batters collapse to cards
// under 640px), and a white, ink-light, single-page letter layout when printed / saved as PDF.
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./firebase.js";

const fmtWhen = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleString("en-US", { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }); } catch { return ""; }
};
const fmtTime = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }); } catch { return ""; }
};

const CSS = `
.sr{--bg:#0c1e09;--surface:#111f0d;--surface2:#162b11;--border:#3a7029;--gold:#d9c20d;--text:#e8f0e6;--mid:#8faa8a;--dim:#6b8a66;--red:#ef4444;--teal:#34d399;
  background:var(--bg);color:var(--text);min-height:100vh;font-family:var(--font-family-body,system-ui,-apple-system,"Segoe UI",sans-serif);font-size:14px;line-height:1.35;padding:16px 16px 48px}
.sr *{box-sizing:border-box}
.sr-wrap{max-width:980px;margin:0 auto}
.sr-bar{display:flex;gap:8px;justify-content:space-between;align-items:center;margin-bottom:14px}
.sr-btn{background:transparent;color:var(--gold);border:1px solid #d9c20d66;border-radius:4px;padding:8px 14px;font-size:12px;letter-spacing:1.5px;cursor:pointer;font-family:inherit;text-decoration:none}
.sr-btn:hover{background:#d9c20d18}
.sr-head{border-bottom:3px solid var(--gold);padding-bottom:10px;margin-bottom:12px}
.sr-title{font-family:var(--font-family-display,inherit);font-size:26px;letter-spacing:1px;color:var(--gold);line-height:1.1;margin:0}
.sr-sub{color:var(--mid);font-size:12.5px;margin-top:4px}
.sr-pitcher{margin-top:6px;font-size:14px}
.sr-pitcher b{color:var(--gold)}
.sr-sec{margin-top:16px}
.sr-h{font-size:11px;letter-spacing:2.5px;color:var(--gold);font-weight:700;margin:0 0 6px;display:flex;gap:10px;align-items:baseline;flex-wrap:wrap}
.sr-h small{letter-spacing:.3px;font-weight:400;color:var(--dim);font-size:11px}
.sr-def{margin:0;padding:10px 12px 10px 28px;background:var(--surface);border:1px solid var(--border);border-radius:6px}
.sr-def li{margin:3px 0}
table.sr-t{width:100%;border-collapse:collapse}
.sr-t th{font-size:10px;letter-spacing:1px;color:var(--dim);font-weight:600;text-align:left;padding:6px;border-bottom:1px solid var(--border);vertical-align:bottom}
.sr-t td{padding:7px 6px;border-bottom:1px solid #3a702955;vertical-align:top}
.sr-t td.n,.sr-t th.n{text-align:center;white-space:nowrap}
.sr-num{color:var(--gold);font-weight:700}
.sr-name{font-weight:600}
.sr-tag{display:block;font-size:10px;letter-spacing:.5px;color:var(--mid);margin-top:2px}
.sr-num-inline{display:none}
.sr-tag.threat{color:var(--red);font-weight:700}
.sr-spray{display:inline-flex;gap:2px}
.sr-spray span{min-width:22px;text-align:center;padding:1px 3px;border-radius:3px;background:var(--surface2);font-variant-numeric:tabular-nums}
.sr-spray span.hi{background:#d9c20d33;color:var(--gold);font-weight:700}
.sr-do{font-weight:500}
.sr-wild{color:var(--red);font-weight:700;letter-spacing:1px}
.sr-row-un td{color:var(--mid);font-style:italic}
.sr-others{color:var(--mid);font-size:12px;margin-top:6px}
.sr-foot{margin-top:18px;color:var(--dim);font-size:11px;border-top:1px solid var(--border);padding-top:8px}
.sr-warn{margin-top:10px;padding:8px 10px;border:1px solid #ef444466;background:#ef444412;border-radius:6px;font-size:12px;color:#fca5a5}
.sr-msg{max-width:420px;margin:15vh auto;text-align:center;color:var(--mid)}
.sr-msg h1{color:var(--gold);font-size:20px;letter-spacing:2px}
@media (max-width:640px){
  .sr-title{font-size:21px}
  .sr-bt thead{display:none}
  .sr-bt tr{display:grid;grid-template-columns:auto 1fr auto;gap:2px 10px;padding:10px 0;border-bottom:1px solid #3a702955}
  .sr-bt td{border:0;padding:0}
  .sr-bt td.c-spot{grid-row:1/3;font-size:18px;color:var(--dim);align-self:center}
  .sr-bt td.c-num{display:none}
  .sr-num-inline{display:inline}
  .sr-bt td.c-name{grid-column:2}
  .sr-bt td.c-pa{grid-column:3;grid-row:1;color:var(--dim)}
  .sr-bt td.c-pa::after{content:" PA"}
  .sr-bt td.c-spray{grid-column:2;grid-row:2}
  .sr-bt td.c-take{grid-column:3;grid-row:2;color:var(--mid)}
  .sr-bt td.c-take::after{content:" take"}
  .sr-bt td.c-do{grid-column:1/4;margin-top:4px}
  .sr-pt thead{display:none}
  .sr-pt tr{display:grid;grid-template-columns:1fr auto;gap:2px 10px;padding:10px 0;border-bottom:1px solid #3a702955}
  .sr-pt td{border:0;padding:0}
  .sr-pt td.c-stats{grid-column:1/3;color:var(--mid);font-size:12px}
  .sr-pt td.c-do{grid-column:1/3}
  .sr-pt td.c-hide{display:none}
}
@media (min-width:641px){.sr-pt td.c-stats{display:none}}
@media print{
  @page{size:letter portrait;margin:.35in}
  html,body{background:#fff!important}
  .sr{--bg:#fff;--surface:#fff;--surface2:#f1f5ef;--border:#1f4516;--gold:#1f4516;--text:#000;--mid:#333;--dim:#555;--red:#b91c1c;
    padding:0;font-size:8.2pt;line-height:1.18;min-height:0}
  table.sr-t{table-layout:fixed}
  .sr-bt th:nth-child(1){width:4%}.sr-bt th:nth-child(2){width:4.5%}.sr-bt th:nth-child(3){width:25%}.sr-bt th:nth-child(4){width:4%}
  .sr-bt th:nth-child(5){width:11%}.sr-bt th:nth-child(6){width:9%}.sr-bt th:nth-child(7){width:42.5%}
  .sr-pt th:nth-child(1){width:20%}.sr-pt th:nth-child(2){width:5%}.sr-pt th:nth-child(3){width:8%}.sr-pt th:nth-child(4){width:12%}
  .sr-pt th:nth-child(5){width:6%}.sr-pt th:nth-child(6){width:7%}.sr-pt th:nth-child(7){width:7%}.sr-pt th:nth-child(8){width:35%}
  .sr-name{white-space:nowrap}
  .sr-bar,.sr-warn{display:none!important}
  .sr-head{border-bottom-color:#d9c20d;padding-bottom:4px;margin-bottom:6px}
  .sr-title{font-size:16pt}
  .sr-sub{font-size:8pt;margin-top:1px}
  .sr-pitcher{font-size:9pt;margin-top:2px}
  .sr-sec{margin-top:7px;break-inside:avoid}
  .sr-h{font-size:8pt;margin-bottom:2px}
  .sr-h small{font-size:7pt}
  .sr-def{padding:3px 6px 3px 18px;border-radius:0}
  .sr-def li{margin:0}
  .sr-t th{font-size:7pt;padding:2px 3px;letter-spacing:.2px}
  .sr-t th.n{white-space:normal}
  .sr-t td{padding:1.6px 3px}
  .sr-t tr{break-inside:avoid}
  .sr-spray span{min-width:15px;padding:0 2px}
  .sr-spray span.hi{background:#fde68a;color:#000}
  .sr-tag{display:inline;font-size:6.6pt;margin:0 0 0 5px}
  .sr-others{font-size:7.5pt;margin-top:2px}
  .sr-foot{font-size:6.8pt;margin-top:6px;padding-top:3px}
  .sr-pt td.c-stats{display:none}
}
`;

function Spray({ s }) {
  const max = Math.max(s.L, s.M, s.R);
  const cls = (v) => (max > 0 && v === max ? "hi" : "");
  return (
    <span className="sr-spray" title="Left / Middle / Right">
      <span className={cls(s.L)}>{s.L}</span><span className={cls(s.M)}>{s.M}</span><span className={cls(s.R)}>{s.R}</span>
    </span>
  );
}

const pctTxt = (v) => (v == null ? "–" : `${v}%`);

export function ScoutingReportBody({ rpt }) {
  const r = rpt.generated;
  const lp = r.likelyPitcher;
  const opp = rpt.opponentName || r.opponentName;
  return (
    <>
      <div className="sr-head">
        <h1 className="sr-title">{rpt.gameDate ? `${fmtTime(rpt.gameDate)} — ` : ""}{opp}</h1>
        <div className="sr-sub">
          {[rpt.gameDate && fmtWhen(rpt.gameDate).replace(/, \d{1,2}:\d{2}.*$/, ""), rpt.teamName, rpt.location, `${r.gameCount} game${r.gameCount !== 1 ? "s" : ""}, ${r.paCount} PA (${r.dateFrom}${r.dateTo && r.dateTo !== r.dateFrom ? `–${r.dateTo}` : ""})`].filter(Boolean).join(" • ")}
        </div>
        {lp && <div className="sr-pitcher">Likely pitcher: <b>{lp.name}{lp.num ? ` #${lp.num}` : ""}</b> ({lp.starts} of last {lp.of} start{lp.of !== 1 ? "s" : ""})</div>}
      </div>

      <div className="sr-sec">
        <div className="sr-h">DEFENSE</div>
        <ul className="sr-def">{r.defense.map((d, i) => <li key={i}>{d}</li>)}</ul>
      </div>

      <div className="sr-sec">
        <div className="sr-h">BATTERS <small>Spray = balls in play by fielder: Left 3B/SS/LF · Mid P/C/CF · Right 1B/2B/RF</small></div>
        <table className="sr-t sr-bt">
          <thead><tr><th className="n">Spot</th><th className="n">#</th><th>Batter</th><th className="n">PA</th><th className="n">Spray L / M / R</th><th className="n">1st-pitch take</th><th>Do this</th></tr></thead>
          <tbody>
            {r.batters.map((b) => (
              <tr key={b.name}>
                <td className="n c-spot">{b.spot ?? "–"}</td>
                <td className="n c-num sr-num">{b.num ?? "–"}</td>
                <td className="c-name">
                  <span className="sr-name">{b.name}</span>{b.num && <span className="sr-num sr-num-inline"> #{b.num}</span>}
                  {b.tags.map((t) => <span key={t} className={`sr-tag${t.startsWith("TOP 3") ? " threat" : ""}`}>{t}</span>)}
                </td>
                <td className="n c-pa">{b.pa}</td>
                <td className="n c-spray"><Spray s={b.spray} /></td>
                <td className="n c-take">{pctTxt(b.firstPitchTakePct)}</td>
                <td className="c-do sr-do">{b.doThis}</td>
              </tr>
            ))}
            {r.unnamed && (
              <tr className="sr-row-un">
                <td className="n c-spot">–</td><td className="n c-num">–</td>
                <td className="c-name"><span className="sr-name">Unnamed batters</span><span className="sr-tag">blank names on GC</span></td>
                <td className="n c-pa">{r.unnamed.pa}</td>
                <td className="n c-spray"><Spray s={r.unnamed.spray} /></td>
                <td className="n c-take">{pctTxt(r.unnamed.firstPitchTakePct)}</td>
                <td className="c-do">{r.unnamed.doThis}</td>
              </tr>
            )}
          </tbody>
        </table>
        {r.others?.length > 0 && (
          <div className="sr-others">Others (PA, 1st-pitch take): {r.others.map((o) => `${o.name}${o.num ? ` #${o.num}` : ""} ${o.pa} PA, ${pctTxt(o.firstPitchTakePct)}`).join(" · ")}</div>
        )}
      </div>

      <div className="sr-sec">
        <div className="sr-h">PITCHERS <small>WILD = under 55% strikes, or (BB+HBP+WP) per batter faced of 14%+</small></div>
        <table className="sr-t sr-pt">
          <thead><tr><th>Pitcher</th><th className="n">BF</th><th className="n">Strike %</th><th className="n">1st-pitch strike %</th><th className="n">BB %</th><th className="n">WP / PB</th><th className="n">Wild?</th><th>Do this</th></tr></thead>
          <tbody>
            {r.pitchers.map((p) => (
              <tr key={p.name}>
                <td><span className="sr-name">{p.name}{p.num ? ` #${p.num}` : ""}</span>{p.likely && <span className="sr-tag threat">likely start</span>}</td>
                <td className="n c-hide">{p.bf}</td>
                <td className="n c-hide">{pctTxt(p.strikePct)}</td>
                <td className="n c-hide">{pctTxt(p.firstStrikePct)}</td>
                <td className="n c-hide">{pctTxt(p.bbPct)}</td>
                <td className="n c-hide">{p.wp}/{p.pb}</td>
                <td className="n">{p.wild == null ? "n/a" : p.wild ? <span className="sr-wild">WILD</span> : "no"}</td>
                <td className="c-stats">{p.bf} BF · {pctTxt(p.strikePct)} strikes · {pctTxt(p.firstStrikePct)} 1st-pitch strikes · {pctTxt(p.bbPct)} BB · WP/PB {p.wp}/{p.pb}</td>
                <td className="c-do sr-do">{p.doThis}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="sr-foot">
        {opp} | Source: GameChanger play-by-play, {r.gameCount} game{r.gameCount !== 1 ? "s" : ""} through {r.dateTo}{r.lookbackDays ? ` (last ${r.lookbackDays} days before this game)` : ""}. Handedness unknown (left/right = fielder who handled the ball). OPS/stats approximate, from play text.
        {" "}Generated {fmtWhen(r.generatedAt)}.
      </div>
      {r.warnings?.length > 0 && (
        <div className="sr-warn">Admin note — some games didn't fully match GameChanger's box score, so numbers may be slightly off:<br />{r.warnings.map((w, i) => <div key={i}>• {w}</div>)}</div>
      )}
    </>
  );
}

export default function ScoutingReport({ gameId }) {
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    document.title = "Scouting Report";
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) { setState({ status: "signin" }); return; }
      try {
        const snap = await getDoc(doc(db, "gcScoutingReports", gameId));
        if (!snap.exists() || !snap.data().generated) { setState({ status: "missing", fileUrl: snap.exists() ? snap.data().fileUrl : null }); return; }
        const rpt = snap.data();
        document.title = `Scouting: ${rpt.opponentName || "Opponent"}`;
        setState({ status: "ok", rpt });
      } catch (e) {
        setState({ status: e?.code === "permission-denied" ? "denied" : "error", message: e?.message });
      }
    });
    return unsub;
  }, [gameId]);

  let body;
  if (state.status === "loading") body = <div className="sr-msg">Loading scouting report…</div>;
  else if (state.status === "signin") body = <div className="sr-msg"><h1>SIGN IN</h1><p>Scouting reports are for Warriors coaches. Sign in to the Warriors app, then open this link again.</p><a className="sr-btn" href="/">OPEN WARRIORS APP</a></div>;
  else if (state.status === "denied") body = <div className="sr-msg"><h1>COACHES ONLY</h1><p>This account can't view scouting reports.</p></div>;
  else if (state.status === "missing") body = <div className="sr-msg"><h1>NO REPORT YET</h1><p>No generated scouting report for this game.</p>{state.fileUrl && <a className="sr-btn" href={state.fileUrl}>OPEN UPLOADED REPORT</a>}</div>;
  else if (state.status === "error") body = <div className="sr-msg"><h1>ERROR</h1><p>{state.message || "Could not load the report."}</p></div>;
  else body = (
    <>
      <div className="sr-bar">
        <a className="sr-btn" href="/">← APP</a>
        <button className="sr-btn" onClick={() => window.print()}>🖨 PRINT / PDF</button>
      </div>
      <ScoutingReportBody rpt={state.rpt} />
    </>
  );

  return (
    <div className="sr">
      <style>{CSS}</style>
      <div className="sr-wrap">{body}</div>
    </div>
  );
}

export { CSS as SCOUTING_REPORT_CSS };
